module.exports = __webpack_public_path__ + "img/wifi-off.a0a88516.svg";